import RenderToast from '@/components/RenderToast';
import { useEffect } from 'react';

const useCloseModalOnNotFound = (error, closeModal) => {
  useEffect(() => {
    if (error?.status === 404) {
      closeModal();
      RenderToast({ type: "error", message: "Data not found." });
    }
  }, [error, closeModal]);
};

export default useCloseModalOnNotFound;